import type { SensitiveAction } from "@workspace/api-zod";

/**
 * Window-event contract for step-up re-auth (Task #3066).
 *
 * Defined in the lib layer — NOT in the StepUpAuthDialog component — so that
 * lib modules (lib/step-up.ts, lib/admin-api/_client.ts) can reference the
 * event name + payload type without importing "up" into the components build
 * chunk. An upward lib→components import tangles the manualChunks DAG into a
 * cycle, which can trigger a module-init TDZ white-screen. The component
 * imports these from here and re-exports them for backward compatibility.
 * See scripts/check-import-layering.mjs.
 */
export const STEP_UP_EVENT = "bac:step-up-required";

export interface StepUpEventDetail {
  action: SensitiveAction;
  /** Resolve when re-auth succeeds; reject on cancel/failure. */
  resolve: () => void;
  reject: (err: Error) => void;
}
